export const API_URL = "https://api.gkcklinica.com"; 
export const APP_URL = "https://app.gkcklinica.com";